import { type DocumentNode, print } from "graphql";
import type { Client, Sink } from "graphql-ws";

export class Subscription {
	private query: string;
	private observer: Partial<Sink<any>>;
	private variables: any;
	private cleanup: () => void;
	private unsubscribe?: () => void;

	public constructor(
		query: string | DocumentNode,
		observer: Partial<Sink<any>>,
		variables: any,
		cleanup: () => void,
	) {
		this.query = typeof query === "string" ? query : print(query);
		this.observer = observer;
		this.variables = variables;
		this.cleanup = cleanup;
	}

	public listen(client: Client) {
		console.log("Subscription listening");

		this.unsubscribe = client.subscribe(
			{
				query: this.query,
				variables: this.variables,
			},
			{
				next: (res: any) => {
					if (res.error || res.errors) {
						const err = new Error(`Query failed: ${res.error || JSON.stringify(res.errors)}`);

						if (this.observer.error) {
							this.observer.error(err);
						} else {
							throw err;
						}
					} else {
						this.observer.next?.(res.data);
					}
				},
				error: (err) => {
					console.error("Subscription sent error:", err);
					this.observer?.error?.(err);
				},
				complete: () => {
					this.observer?.complete?.();
					this.dispose();
				},
			},
		);
	}

	public dispose() {
		this.unsubscribe?.();
		this.unsubscribe = undefined;
		this.cleanup();
	}
}
